<template>
  <div class="nav">
    <div class="nav-box">
      <div class="logo" @click="toPage('homeP')">
        <img src="https://cdn1.p2ipo.com/pc/home/jdzc-logo1.png" alt />
        <div class="name-box">
          <p>上市孵化器</p>
          <p>Listing incubator</p>
        </div>
      </div>
      <div class="carousel">
        <div class="title-box">
          <div class="msg-img">
            <img src="../../../../assets/img/msg.png" alt />
          </div>
          <span class="msg-title">挂牌企业：</span>
        </div>
        <div class="txt-box">
          <div class="content" id="gun">
            <span v-for="(item, i) in msgList" :key="i">{{item.short_name}}&nbsp;({{item.gua_code}})</span>
          </div>
        </div>
      </div>
    </div>
    <nav>
      <div class="menu-box">
        <ul id="navList">
          <li v-for="(item, i) in navList" :key="i" :id="item.id" :class="{isactive:navActive==i}">{{item.name}}</li>
        </ul>
        <!-- <div class="page-nav-box">
          <PageNav></PageNav>
        </div> -->
      </div>
    </nav>
  </div>
</template>
<script>
export default {
  name: "navsP",
  data() {
    return {
      navList: [
        { id: 'homeP', name: '首页' },
        { id: 'listedP', name: '挂牌企业' },
        { id: 'incubatorP', name: '孵化基地' },
        { id: 'baseP', name: '产业集群' },
        { id: 'investorP', name: '与投资者关系' },
        { id: 'dutyP', name: '企业社会责任' },
        { id: 'ruleP', name: '系统规则' }
      ],
      navActive: 0, // 选中的导航项
      msgList: [] // 跑马灯数据
    };
  },
  mounted() {
    this.getnavActive(); // 开启监听导航菜单选中状态
    this.msgMove(); // 开启注册企业跑马灯效果
    this.listenNav(); // 监听导航点击事件
  },
  methods: {
    getnavActive() {
      // 刷新页面重新获取导航菜单选中状态
      let flag = this.cm.getSessionData('navStatus');
      if(flag) {
        this.navActive = this.cm.getSessionData('navStatus').navStatus;
      }
      // 跳转页面监听导航菜单选中状态
      this.Bus.$on("navStatus", data => {
        // console.log('navStatus>>>', data);
        this.navActive = data;
      });
      // console.log('navStatus>>>', this.navActive);
    },
    msgMove() {
      // 获取注册企业数据
      this.$axios.get(this.urls.companyList, {
          params: { limit: 10 }
      }).then(res => {
          this.msgList = res.data.data.data;
          // 拿到数据后去开启跑马灯
          let gunDiv = document.getElementById("gun");
          let i = 490;
          this.actionMove(gunDiv, i);
        });
    },
    actionMove(gunDiv, i) {
      let gunCount = Number(gunDiv.clientWidth) + i;
      let timer = setInterval(() => {
        if (gunCount > 0) {
          gunCount--;
          i -= 1;
          gunDiv.style.left = i + "px";
        } else {
          clearInterval(timer);
          setTimeout(() => {
            this.actionMove(gunDiv, 490);
          }, 1000);
        }
      }, 20);
    },
    listenNav() {
      document.getElementById("navList").addEventListener( "click", event => {
        let val = event.target.id, path = '', navStatus = null, key = null, value = null, pnObj = null, sessionData = null;
        switch (val) {
          case 'homeP':
            path = val;
            navStatus = 0;
            break;
          case 'listedP':
            key = path = val;
            navStatus = 1;
            value = {
              inputData: '',
              salceData: 0,
              type: { one: '', two: '', three: '', four: '' },
              page: 1
            };
            sessionData = {
              data: { key: key, value: value, navKey: 'nav' + key, pageNavList: [ { name: 'homeP', title: '首页', active: 0 } ] },
              isBlank: false
            };
            break;
          case 'incubatorP':
            key = path = 'incDefaultP';
            navStatus = 2;
            value = { 
              inputVal: '', regIdx: -1, regName: '', strIdx: -1, strName: '', comIdx: -1, comName: '', areaId: 'longgang', areaName: '龙岗区', page: 1
            };
            sessionData = {
              data: { key: key, value: value, navKey: 'nav' + key, pageNavList: [ { name: 'homeP', title: '首页', active: 0 } ] },
              isBlank: false
            };
            break;
          case 'baseP':
            key = path = val;
            navStatus = 3;
            sessionData = {
              data: { key: key, value: {}, navKey: 'nav' + key, pageNavList: [ { name: 'homeP', title: '首页', active: 0 } ] },
              isBlank: false
            };
            break;
          case 'investorP':
            key = path = val;
            navStatus = 4;
            sessionData = {
              data: { key: key, value: {}, navKey: 'nav' + key, pageNavList: [ { name: 'homeP', title: '首页', active: 0 } ] },
              isBlank: false
            };
            break;
          case 'dutyP':
            key = path = val;
            navStatus = 5;
            sessionData = {
              data: { key: key, value: {}, navKey: 'nav' + key, pageNavList: [ { name: 'homeP', title: '首页', active: 0 } ] },
              isBlank: false
            };
            break;
          case 'ruleP':
            key = path = val;
            navStatus = 6;
            sessionData = {
              data: { key: key, value: {}, navKey: 'nav' + key, pageNavList: [ { name: 'homeP', title: '首页', active: 0 } ] },
              isBlank: false
            };
            break;
          default:
            break;
        }
        // 跳转页面公共方法
        if(sessionData) {
          this.cm.toPage(path, navStatus, sessionData);
        } else {
          this.cm.toPage(path, navStatus);
        }
      }, true);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./NavsP.scss";
</style>


// WEBPACK FOOTER //
// src/components/pc/common/navs/NavsP.vue